import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TelegramLogo, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export function TelegramConnectCard() {
  const [connected, setConnected] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const timer = useRef(null);

  const check = () => api.get("/telegram/status").then((r) => {
    setConnected(r.data.connected);
    if (r.data.connected) { setWaiting(false); clearInterval(timer.current); }
    return r.data.connected;
  }).catch(() => {});

  useEffect(() => { check(); return () => clearInterval(timer.current); }, []);

  const connect = async () => {
    const win = window.open("", "_blank");
    try {
      const { data } = await api.post("/telegram/link");
      if (win) win.location.href = data.url; else window.location.href = data.url;
      setWaiting(true);
      clearInterval(timer.current);
      let n = 0;
      timer.current = setInterval(async () => {
        n += 1;
        if ((await check()) ) toast.success("Telegram conectado!");
        if (n > 60) { clearInterval(timer.current); setWaiting(false); }
      }, 5000);
    } catch { win?.close(); toast.error("Não foi possível gerar o link"); }
  };

  const disconnect = async () => {
    await api.delete("/telegram/link");
    setConnected(false);
    toast.success("Telegram desconectado");
  };

  return (
    <Card data-testid="telegram-connect-card">
      <CardHeader><CardTitle className="text-lg flex items-center gap-2"><TelegramLogo size={22} weight="fill" className="text-sky-500" /> Avisos no Telegram</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-slate-600">Receba no seu Telegram os avisos de revisão por KM e de chegada/saída dos postos e clientes cadastrados.</p>
        {connected ? (
          <div className="flex flex-wrap items-center gap-3">
            <span data-testid="telegram-status-connected" className="inline-flex items-center gap-1.5 text-emerald-700 font-semibold text-sm"><CheckCircle size={18} weight="fill" /> Conectado</span>
            <Button variant="outline" size="sm" onClick={disconnect} data-testid="btn-telegram-disconnect">Desconectar</Button>
          </div>
        ) : (
          <>
            <Button onClick={connect} data-testid="btn-telegram-connect" className="bg-sky-500 hover:bg-sky-600 text-white gap-2">
              <TelegramLogo size={18} weight="fill" /> Conectar Telegram
            </Button>
            {waiting && <p data-testid="telegram-waiting" className="text-xs text-slate-500">No Telegram, toque em <b>Iniciar</b> (ou "Start"). Esta tela confirma sozinha em alguns segundos.</p>}
          </>
        )}
      </CardContent>
    </Card>
  );
}
